<div class="page-container br-1em hover-on-active height-6p5em  bg-black-3 aligned-row-container"
  (click)="onClick()">
  <div class="space-between-horizontal-centered width-100pcnt">
    <div class="start-row-container pd-1p875em">
      <app-all-icons class="icon-size-2em" [iconNameAndStyling]="method.id + '.svg'"></app-all-icons>
      <div class="title-3em bold500 pd-0p5em">
        <div *ngIf="isActive; else notActive">Resend code on {{method.name}}</div>
        <ng-template #notActive>Change to {{method.name}}</ng-template>
      </div>
    </div>
    <app-all-icons class="icon-size-1p5em opacity-50 pd-1p875em" [iconNameAndStyling]="'right-arrow.svg'"></app-all-icons>
  </div>
</div>